import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { environment } from '../../../environments/environment';
import { skipLoading } from '../interceptors/skip-loading.context';

export interface ListaPlanillaPersona {
  id: string;
  nombre: string;
  apellido: string;
  miLider: string;
  nacimiento: string | null;
  sexo: string | null;
}

export interface ListaLiderOpcion {
  id: string;
  nombre: string;
  apellido: string;
}

export interface ListaPlanilla {
  fechaDom: string;
  abierta: boolean;
  celulaName: string;
  mostrarLider: boolean;
  elegirLider: boolean;
  lideres: ListaLiderOpcion[];
  idLider: string | null;
  personas: ListaPlanillaPersona[];
}

interface ListaPlanillaResponse {
  success: boolean;
  data: ListaPlanilla;
}

export interface ListaLotePersona {
  idUser: string;
  celula: boolean;
  domingo: boolean;
}

export interface ContadorInforme {
  id: string;
  usuario: string;
  cantidad: number;
  horario: string;
}

@Injectable({ providedIn: 'root' })
export class ListaService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  planilla(idLider?: string): Observable<ListaPlanilla> {
    return this.http
      .get<ListaPlanillaResponse>(`${this.apiUrl}/lista/planilla`, {
        context: skipLoading(),
        params: idLider ? { idLider } : undefined,
      })
      .pipe(map((response) => response.data));
  }

  enviarLote(personas: ListaLotePersona[]): Observable<void> {
    return this.http
      .post<unknown>(
        `${this.apiUrl}/lista/lote`,
        { personas },
        { context: skipLoading() },
      )
      .pipe(map(() => undefined));
  }

  ultimaToma(idLider?: string): Observable<string | null> {
    return this.http
      .get<{ success: boolean; data: { tomadaEn: string | null } }>(`${this.apiUrl}/lista/ultima`, {
        context: skipLoading(),
        params: idLider ? { idLider } : undefined,
      })
      .pipe(map((response) => response.data.tomadaEn));
  }

  historialContador(): Observable<ContadorInforme[]> {
    return this.http
      .get<{ success: boolean; data: ContadorInforme[] }>(`${this.apiUrl}/lista/contador`, {
        context: skipLoading(),
      })
      .pipe(map((response) => response.data));
  }

  enviarContador(contador: number): Observable<void> {
    return this.http
      .post<unknown>(
        `${this.apiUrl}/lista/contador`,
        { contador },
        { context: skipLoading() },
      )
      .pipe(map(() => undefined));
  }
}
